import { lazy, Suspense } from 'react';

import { ClassNames } from '@emotion/react';
import LinearProgress from '@zenbusiness/zui/LinearProgress';
import PropTypes from 'prop-types';

import { checkIsMobile } from '#client/utils/devices';

import {
  LazyTransformWrapper,
  TransformWrapperDefault,
  LazyTransformComponent,
  TransformComponentDefault
} from './components/Transform';

const isMobile = checkIsMobile();
const TransformWrapper = isMobile ? lazy(LazyTransformWrapper) : TransformWrapperDefault;
const TransformComponent = isMobile ? lazy(LazyTransformComponent) : TransformComponentDefault;

const PinchZoom = ({ children, centerOnInit }) => (
  <Suspense fallback={<LinearProgress />}>
    <TransformWrapper
      centerOnInit={centerOnInit}
      wheel={{ disabled: true }}
    >
      <ClassNames>
        {({ css, cx }) => (
          <TransformComponent
            contentClass={cx(css`
              height: auto;
              margin: 0 auto;
            `)}
            wrapperClass={cx(css`
              height: 100% !important;
              width: 100%;
              overflow-y: scroll;
            `)}
          >
            {children}
          </TransformComponent>
        )}
      </ClassNames>
    </TransformWrapper>
  </Suspense>
);

PinchZoom.propTypes = {
  children: PropTypes.node.isRequired,
  centerOnInit: PropTypes.bool
};

export default PinchZoom;
